var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TopicTitle"},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"topic title"}}),_c('h1',[_vm._v(" "+_vm._s(_vm.questionsCount)+" "+_vm._s(_vm.getCurrentTopic.displayName)+" interview questions. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }